import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

// Redux slices
import userReducer from '../slice/auth/user-slice'; // Fixed typo

import { logout } from '../slice/auth/user-slice';

// Middleware to check the last login time and dispatch the logout action if needed
const expirationMiddleware = (store) => (next) => (action) => {
  try {
    const currentTime = Date.now();
    const lastLoginTime = store.getState().user?.lastLoginTime;

    // Check if the action is the logout action to prevent recursion
    if (action.type === logout.type) {
      return next(action);
    }

    // Dispatch logout if session has expired
    if (lastLoginTime && currentTime - lastLoginTime >= 3 * 60 * 60 * 1000) {
      store.dispatch(logout());
      return;
    }

    return next(action);
  } catch (error) {
    console.error("Error in expirationMiddleware:", error);
    return next(action); // Allow other actions to proceed in case of an error
  }
};


// Persist configuration
const persistConfig = {
  key: 'root',
  storage: storage,
};

const rootReducer = combineReducers({
  user: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with middleware
export const store = configureStore({
  reducer: persistedReducer, // Use persistedReducer instead of appReducer
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(expirationMiddleware), // Include the expiration middleware
});

// Persistor
export const persistor = persistStore(store);
